export const GPS_FIX_MAX_UNEXPLAINED_DISPLACEMENT_M = 15

export const GPS_FIX_MAX_PLAUSIBLE_GROUND_SPEED_KMH = 500

export const GPS_FIX_MAX_USABLE_DOP = 5

export const GPS_FIX_RESYNC_S = 2

export const GPS_FIX_MIN_MOVING_SPEED_KMH = 20

export const GPS_FIX_TRUSTED_SPEED_TO_TRACK_RATIO = { min: 0.8, max: 1.25 }
